var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen && _vm.popupList.length > 0
    ? _c(
        "div",
        { staticClass: "main_notice_modal" },
        [
          _c("div", { staticClass: "modal_layer" }),
          _c("e-slider", {
            staticClass: "modal_swiper",
            attrs: {
              items: _vm.popupList,
              widths: _vm.cardWidths,
              "left-peek": 40,
              "right-peek": 40,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ item: popup }) {
                    return [
                      _c("div", { staticClass: "notice_slide" }, [
                        _c("div", { staticClass: "slide_tit" }, [
                          popup.ntcCatCd === "Y"
                            ? _c("span", { staticClass: "label important" }, [
                                _vm._v(_vm._s(_vm.$t("msg.CMBA100.533"))),
                              ])
                            : _vm._e(),
                          _c("span", [_vm._v(_vm._s(popup.messageCont))]),
                        ]),
                        _c("div", { staticClass: "slide_cont_wrap" }, [
                          _c(
                            "div",
                            {
                              class: [
                                "slide_cont",
                                { img_type: popup.templUseYn === "N" },
                              ],
                              style:
                                popup.templUseYn === "Y"
                                  ? {
                                      "background-color":
                                        _vm.$ekmtcCommon.setPopupBgColor(
                                          popup.templBtypeCd
                                        ),
                                    }
                                  : null,
                            },
                            [
                              popup.templUseYn === "N"
                                ? _c("img", { attrs: { src: popup.imgSrc } })
                                : _vm._e(),
                              popup.templUseYn === "Y"
                                ? _c("div", {
                                    staticClass: "tmpl_cont",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$ekmtcCommon.popupTextToHtml(
                                          popup.messageDtl
                                        )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm.hasButton(popup)
                            ? _c("div", { staticClass: "btn_detail_wrap" }, [
                                popup.btn1Nm && popup.btn1Nm.trim()
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn_detail",
                                        attrs: {
                                          href: popup.btn1Url,
                                          title: popup.btn1Nm,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(popup.btn1Nm))]
                                    )
                                  : _vm._e(),
                                popup.btn2Nm && popup.btn2Nm.trim()
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn_detail",
                                        attrs: {
                                          href: popup.btn2Url,
                                          title: popup.btn2Nm,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(popup.btn2Nm))]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "btn_close_wrap" }, [
                          _c(
                            "button",
                            {
                              staticClass: "day_close",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.closeToday()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.NOTICE_POP.001")))]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "popup_close",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.isOpen = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("msg.MAIN100.228")))]
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ],
              null,
              false,
              4019691735
            ),
            model: {
              value: _vm.currentIndex,
              callback: function ($$v) {
                _vm.currentIndex = $$v
              },
              expression: "currentIndex",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }